module.exports = __webpack_public_path__ + "media/application/images/icons/computer-210adb85a8858ddc99a71285b170afca.png";